import moment from "moment";
import CButton from "@/components/controls/button";
import CButton2 from "@/components/controls2/Button";
import SvgIcon from "@/components/svg-icon";
import CSwitcher from "@/components/controls/switcher";
import CInput2 from "@/components/controls2/Input";
import CPeriod from "@/components/period";
import FileLoader from "@/components/file-loader";
import ErrorFeedback from "@/components/error-feedback";
import placeholder from "@/assets/images/userpic.svg";
import RemoveVacationModal from "../remove-vacation-modal";

export default {
    name: "vacation-modal",

    components: {
        CButton,
        CButton2,
        SvgIcon,
        CSwitcher,
        CInput2,
        CPeriod,
        FileLoader,
        ErrorFeedback,
        RemoveVacationModal,
    },

    props: ["canEdit", "start", "period"],

    data() {
        return {
            placeholder,
            active: false,

            submitted: false,

            vacation: null,
            id: null,

            form: {
                type: "vacation",
                employee: null,
                vacationType: null,
                period: {
                    start: null,
                    end: null,
                },
            },

            files: [],
            fileLink: null,

            collections: {
                employees: [],
                vacationTypes: [],
            },

            worker: null,

            serverError: null,
        };
    },

    computed: {
        title() {
            if (!this.id) return "Добавить отпуск/больничный";

            if (this.canEdit) {
                return `Изменить ${this.form.type === "sick" ? "больничный" : "отпуск"}`;
            }

            if (this.form.type === "sick") return "Больничный";

            return `<span style="font-weight: 400">Отпуск</span> ${this.form.vacationType.label}`;
        },
        fileLinks() {
            return [this.fileLink].filter(Boolean);
        },
        employeeError() {
            if (!this.submitted) return null;
            if (!this.form.employee) return "Обязательное поле";
            return null;
        },
        vacationTypeError() {
            if (!this.submitted) return null;
            if (this.form.type !== "vacation") return null;
            if (!this.form.vacationType) return "Обязательное поле";
            return null;
        },

        isValid() {
            return !(this.employeeError || this.vacationTypeError);
        },
    },

    created() {
        this.$store.dispatch("vacationsChart/getEmployeesList").then((items) => {
            this.collections.employees = items;
        });
        this.$store.dispatch("referenceVacationTypes/loadTypes").then((items) => {
            this.collections.vacationTypes = items
                .filter((i) => !i.is_sick)
                .map((i) => ({
                    value: i.id,
                    label: i.name,
                }));
        });
    },

    methods: {
        open(params = {}) {
            if (params.vacation) {
                this.vacation = params.vacation;
                const { vacation } = params;
                this.id = vacation.id;

                this.form.type = vacation.category;
                this.form.employee = {
                    value: vacation.worker.id,
                    label: vacation.worker.name,
                };
                if (this.collections.employees.length) {
                    this.form.employee = this.collections.employees.find((e) => e.value === vacation.worker.id);
                }
                if (vacation.category === "vacation") {
                    this.form.vacationType = {
                        value: vacation.type.id,
                        label: vacation.type.name,
                    };
                }
                if (vacation.file) {
                    this.fileLink = {
                        id: "0",
                        url: `/upload/vacations/${vacation.file}`,
                    };
                }

                this.form.period.start = moment(vacation.from_dt).format("DD.MM.YYYY");
                this.form.period.end = moment(vacation.to_dt).format("DD.MM.YYYY");
            } else {
                if (params.start) {
                    this.form.period.start = params.start;
                }
                if (params.worker) {
                    this.form.employee = {
                        value: params.worker.id,
                        label: params.worker.name,
                    };
                    if (this.collections.employees.length) {
                        this.form.employee = this.collections.employees.find((e) => e.value === params.worker.id);
                    }
                }
            }

            this.worker = params.worker;

            this.active = true;
        },

        close() {
            this.active = false;
            this.$emit("close");
            this.reset();
        },

        getParams() {
            const params = {
                period: this.form.period,
                employee: this.form.employee.value,
                type: this.form.type,
            };

            if (this.form.type === "vacation" && this.form.vacationType) {
                params.vacationType = this.form.vacationType.value;
            }

            if (this.files.length) {
                const [firstFile] = this.files;
                params.file = firstFile;
            } else if (this.fileLink) {
                params.fileLink = this.fileLink.url;
            }

            if (this.id) {
                params.id = this.id;
            }

            return params;
        },

        submit() {
            this.submitted = true;
            this.$refs.period.validate();
            if (!this.isValid) return;
            if (!this.$refs.period.isValid) return;

            const params = this.getParams();
            if (this.id) {
                this.$store.dispatch("vacationsChart/updateVacation", params).then((res) => {
                    if (res.success) {
                        this.close();
                        setTimeout(() => {
                            this.$emit("success", res.model);
                        });
                    } else {
                        const { from_dt, to_dt } = res.errors || {};
                        let serverError = null;
                        if (from_dt) {
                            const [firstDate] = from_dt;
                            serverError = firstDate;
                        } else if (to_dt) {
                            const [firstDate] = from_dt;
                            serverError = firstDate;
                        }
                        this.serverError = serverError;
                    }
                });
            } else {
                this.$store.dispatch("vacationsChart/createVacation", params).then((res) => {
                    if (res.success) {
                        this.close();
                        setTimeout(() => {
                            this.$emit("success", res.model);
                        });
                    } else {
                        const { from_dt, to_dt } = res.errors || {};
                        let serverError = null;
                        if (from_dt) {
                            const [firstDate] = from_dt;
                            serverError = firstDate;
                        } else if (to_dt) {
                            const [firstDate] = from_dt;
                            serverError = firstDate;
                        }
                        this.serverError = serverError;
                    }
                });
            }
        },

        onRemove() {
            this.close();
            this.$nextTick(() => {
                this.$emit("remove");
            });
        },

        remove() {
            this.$refs.removeVacationModal.open(this.vacation);
        },

        reset() {
            this.submitted = false;
            this.id = null;
            this.vacation = null;
            this.form.type = "vacation";
            this.form.employee = null;
            this.form.vacationType = null;
            this.files = [];
            this.fileLink = null;
            this.worker = null;

            this.setPeriod(null, null);
        },

        setPeriod(start, end) {
            this.form.period.start = start;
            this.form.period.end = end;
        },
    },

    watch: {
        "form": {
            deep: true,
            handler() {
                this.serverError = null;
            },
        },
        "files": function () {
            this.serverError = null;
        },
        "fileLink": function () {
            this.serverError = null;
        },
        "collections.employees": function (v) {
            if (this.form.employee) {
                this.form.employee = v.find((e) => e.value === this.form.employee.value);
            }
        },
    },
};
